// extracted by mini-css-extract-plugin
export var boxItems = "_a0-1";
export var boxItemsLg = "_a0-2";
export var button = "_a0-7";
export var buttonHoverless = "_a0-9";
export var buttonLg = "_a0-8";
export var filterGroupBox = "_a0-0";
export var icon = "_a0-3";
export var iconSecondary = "_a0-6";
export var iconWrapper = "_a0-4";
export var iconWrapperLg = "_a0-5";
export var truncatedLabel = "_a0-a";